import { createAction } from 'redux-actions';
import {AssetGroup, Location, LocationBookingStats, NotificationType} from '../api/types';

export interface LocationsFetchedPayload {
    locations: Location[];
}

export interface LocationUpdatedPayload {
    id: string;
    enabled: boolean;
    status: {
        bookable: boolean;
        notification?: {
            type: NotificationType;
            text: string;
        };
    };
}

export interface LocationBookingStatsFetchedPayload {
    locationId: number;
    locationBookingStats: LocationBookingStats;
}

export interface AllAssetGroupFetchedPayload {
    assetGroups: AssetGroup[];
}

export interface LocationAvailabilitiesFetchedPayload {
    locationId: string;
    assetGroup: AssetGroup;
}

/* eslint-disable max-len */
export const locationsFetched = createAction<LocationsFetchedPayload>('LOCATIONS_FETCHED');
export const locationUpdated = createAction<LocationUpdatedPayload>('LOCATION_UPDATED');
export const locationBookingStatsFetched = createAction<LocationBookingStatsFetchedPayload>('LOCATION_BOOKING_STATS_FETCHED');
export const allAssetGroupsFetched = createAction<AllAssetGroupFetchedPayload>('ALL_ASSETGROUPS_FETCHED');
export const locationAvailabilitiesFetched = createAction<LocationAvailabilitiesFetchedPayload>(
    'LOCATION_AVAILABILITIES_FETCHED');
